
export const redeemConst = {
    peyType: 2,//打款类型(HS_PAY_TYPE: 1-银行卡 2-Paypal)
    // productId: confJson.productId,
    currency: 'USD',

}
